import { render } from "./lane-item.vue?vue&type=template&id=5da00582&scoped=true"
import script from "./lane-item.vue?vue&type=script&lang=js"
export * from "./lane-item.vue?vue&type=script&lang=js"

import "./lane-item.vue?vue&type=style&index=0&id=5da00582&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\BijouCRM\\src\\ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da00582"]])

export default __exports__